import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { resolvePageTitle } from '@config/pageTitles'
import { getReportPageTitle } from '@features/reports/constants/reportPageTitles'
import { setRouteDocumentTitle } from '@/lib/pageTitle/documentTitle'

/**
 * Applies the route's tab title on every navigation, mirroring how each Angular
 * component calls `AppService.title()` on init. Pages that need a runtime title
 * layer one on top with `usePageTitle`.
 */
export function PageTitleManager() {
  const { pathname } = useLocation()

  useEffect(() => {
    setRouteDocumentTitle(
      pathname,
      resolvePageTitle(pathname) ?? getReportPageTitle(pathname),
    )
  }, [pathname])

  return null
}
